export const KEYWORDS_SCOPE = {
  COMPANY: "company",
  GROUP: "group",
  FACILITY: "facility"
};
